import styled from "styled-components";

export const Service = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 10px;
  width: 90%;

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 48px;
    align-items: center;
    justify-content: center;
  }
`;
export const NumberService = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    font-size: 80px;
    font-weight: 600;
    color: var(--color-yellow);
    line-height: 96px;
  }

  h3 {
    width: 123px;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 23px;
    margin-bottom: 30px;

    @media (min-width: 1024px) {
      width: 180px;
    }
  }
`;
export const ContentService = styled.div`
  text-align: justify;
  font-size: 20px;
  line-height: 35px;
  p {
    padding-bottom: 1.5rem;
  }
`;
